<div fxLayout="column" class="syn--full-height" id="layout-detail">
    <syn-header [text]="headerText" [caption]="headerCaption" [tooltip]="headerTooltip" [matIco]="headerIcon"
        [user]="user" [actions]="actions$ | async" [menuActions]="menuActions$ | async">
    </syn-header>

    <mat-sidenav-container [hasBackdrop]="false">
        <mat-sidenav #slideNav class="syn--do-not-print main mat-elevation-z0" [opened]="true" mode="side">
            <nav>
                <div *ngFor="let nav of navigations" class="syn--navigations">
                    <a *ngIf="nav.show ?? true"
                        [routerLink]="nav.routerLink"
                        [fragment]="nav.fragment"
                        [routerLinkActive]="['sidenav__link--current']"
                        class="syn--navigations_link">
                        <mat-icon [svgIcon]="nav.icon"></mat-icon>
                        <span>{{ nav.text }}</span>

                        @if (nav.status) {
                            <div class="status" [ngStyle]="{'background-color': nav.status.color }">
                                <mat-icon [svgIcon]="nav.status.icon"></mat-icon>
                                @if (nav.status.text) {
                                    <span>{{ nav.status.text }}</span>
                                }
                            </div>
                        }
                    </a>
                    <ul *ngIf="nav.children">
                        <li *ngFor="let navChild of nav.children" class="syn--navigations_child">
                            <a [routerLink]="nav.routerLink"
                                [fragment]="navChild.fragment"
                                [class]="{'sidenav__link_child--current': isActiveChildRoute(navChild)}"
                                class="syn--navigations_link">
                                {{ navChild.text }}
                            </a>
                        </li>
                    </ul>
                </div>
            </nav>
        </mat-sidenav>

        <mat-sidenav-content id="scroll-container">
            <div class="container">
                <ng-content></ng-content>
            </div>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>
